import * as z from "zod";

export const refreshSubscriptionPreOrderDeliveryProfile = {
  name: "refreshSubscriptionPreOrderDeliveryProfile" as const,
  input: z.void(),
  output: z.union([
    z.object({ success: z.literal(true) }),
    z.object({ success: z.literal(false), failureMessage: z.string() }),
  ]),
};
